import { useMemo, useState } from "react";
import { feedTabs, latestFeeds } from "@/mocks/siteData";
import SectionHeader from "./SectionHeader";

const tagColor: Record<string, string> = {
  影视: "bg-primary-100 text-primary-700",
  综艺: "bg-accent-100 text-accent-800",
  明星: "bg-secondary-100 text-secondary-800",
  现场: "bg-primary-50 text-primary-600",
  行业: "bg-background-200 text-foreground-600",
};

export default function LatestFeed() {
  const [tab, setTab] = useState("全部");

  const list = useMemo(
    () => (tab === "全部" ? latestFeeds : latestFeeds.filter((f) => f.category === tab)),
    [tab]
  );

  return (
    <section id="latest" className="relative scroll-mt-20 py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="新瓜速递"
          title="最新资讯，实时跟上"
          desc="按时间倒序滚动更新的信息流，覆盖影视、综艺、明星与现场等多个栏目，不错过任何一条值得讨论的动态。"
        />

        {/* Tab switcher */}
        <div className="inline-flex items-center gap-1 bg-background-50 border border-background-200 rounded-full p-1 mb-8">
          {feedTabs.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTab(t)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                tab === t
                  ? "bg-primary-500 text-background-50 shadow-sm"
                  : "text-foreground-600 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* Timeline */}
        <div className="relative space-y-4 md:space-y-5">
          <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300"></div>
          {list.map((f) => (
            <article key={f.id} className="relative pl-8 md:pl-12">
              <span className="absolute left-0 top-2 md:top-2.5 flex items-center justify-center w-[15px] h-[15px] md:w-[19px] md:h-[19px] rounded-full bg-background-50 border-2 border-primary-500"></span>
              <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5 hover:border-primary-200 hover:shadow-sm transition-all">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className={`px-2 py-0.5 rounded-md text-[11px] font-semibold ${tagColor[f.category] || "bg-secondary-100 text-secondary-800"}`}>
                    {f.category}
                  </span>
                  <span className="text-[11px] text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line text-xs w-3 h-3 flex items-center justify-center"></i>
                    {f.time}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 hover:text-primary-600 transition-colors cursor-pointer">
                  {f.title}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed hidden sm:block">{f.summary}</p>
                <div className="mt-2.5 flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm w-4 h-4 flex items-center justify-center"></i>
                    {f.view} 阅读
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line text-sm w-4 h-4 flex items-center justify-center"></i>
                    {f.comment} 讨论
                  </span>
                </div>
              </div>
            </article>
          ))}
          {list.length === 0 && (
            <p className="py-10 text-center text-sm text-foreground-500">该栏目暂无内容，敬请期待</p>
          )}
        </div>
      </div>
    </section>
  );
}